import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _EmployeeContractType, _InfoForTaxCertificate, _InfoForTaxReporting } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../theme/Input/InputDate";
import { ValueTypeSelector } from "../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { CertificateYears } from "./CertificateYears/CertificateYears";
import { CertificateSheets } from "./CertificateYears/CertificateSheets";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountantYear } from "../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";


export const InfoForTaxCertificate = () => {

    const taxcertify = useDataBean(_InfoForTaxCertificate);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [year, setyear] = useState<any>(null)
    const [sheetName, setsheetName] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])

    const getLista = () => {

        taxcertify.instance.getInfoForTaxCertificateCatalog(year, sheetName).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        taxcertify.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        taxcertify.instance.deleteInfoForTaxCertificate(taxcertify.bean.IDInfoForTaxCertificate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        if (!taxcertify.bean.SheetName) {
            toast.warning("Debe proporcionar una Hoja.");
            return;
        }
        if (!taxcertify.bean.ColumnName) {
            toast.warning("Debe proporcionar una Columna.");
            return;
        }
        if (!taxcertify.bean.ColumnIndex) {
            toast.warning("Debe proporcionar un Índice Columna.");
            return;
        }
        if (!taxcertify.bean.ColumnTag) {
            toast.warning("Debe proporcionar un Tag de Columna.");
            return;
        }
        if (!taxcertify.bean.DefaultValue) {
            toast.warning("Debe proporcionar un Valor por Defecto.");
            return;
        }
        if (!taxcertify.bean.Year) {
            toast.warning("Debe proporcionar una Vigencia.");
            return;
        }
        if (!taxcertify.bean.ValueType) {
            toast.warning("Debe proporcionar un Tipo.");
            return;
        }

        taxcertify.instance.updateInfoForTaxCertificate(taxcertify.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDInfoForTaxCertificate', visible: true },
        { title: 'Hoja', property: 'SheetName', visible: true },
        { title: 'Nombre de Columna', property: 'ColumnName', visible: true },
        { title: 'Índice Columna', property: 'ColumnIndex', visible: true },
        { title: 'Tag de Columna', property: 'ColumnTag', visible: true },
        { title: 'Valor por Defecto', property: 'DefaultValue', visible: true },
        { title: 'Vigencia', property: 'Year', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo', property: 'ValueType', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${taxcertify.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Estructura de Certificado de Ingresos y Retenciones">
            <div className="row">
                <div className="col-md-6">
                    <CertificateYears idSelector={year} onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-6">
                    <CertificateSheets year={year} idSelector={sheetName} onChange={(e) => { setsheetName(e) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={taxcertify.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Hoja</label>
                                <input type="text" name="SheetName" className="form-control" value={taxcertify.bean.SheetName} onChange={taxcertify.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre de Columna</label>
                                <input type="text" name="ColumnName" className="form-control" value={taxcertify.bean.ColumnName} onChange={taxcertify.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Índice Columna</label>
                                <input type="text" name="ColumnIndex" className="form-control" value={taxcertify.bean.ColumnIndex} onChange={taxcertify.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tag de Columna</label>
                                <input type="text" name="ColumnTag" className="form-control" value={taxcertify.bean.ColumnTag} onChange={taxcertify.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor por Defecto</label>
                                <input type="text" name="DefaultValue" className="form-control" value={taxcertify.bean.DefaultValue} onChange={taxcertify.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <AccountantYear idSelector={taxcertify.bean.Year} onChange={(e) => { taxcertify.setBean({ ...taxcertify.bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ValueTypeSelector idSelector={taxcertify.bean.ValueType} onChange={(e) => { taxcertify.setBean({ ...taxcertify.bean, "ValueType": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {taxcertify.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}